// extracted by mini-css-extract-plugin
module.exports = {"footerWrap":"style_footerWrap__haPX6","tip":"style_tip__2Tw1u","shieldLogo":"style_shieldLogo__2I30h","container":"style_container__13NbG","logoLink":"style_logoLink__lTDX2"};